import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ModalData } from "./modalTypes";
export type { ModalData, ModalKind, ModalPayloadMap } from "./modalTypes";
export { modal } from "./modalTypes";

// Slice Logic

export type ModalState = { queue: ModalData[] }

const initialState: ModalState = { queue: [] }

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<ModalData>) => {
      state.queue.push(action.payload);
    },

    hideModal: (state) => {
      state.queue.pop();
    },

    clearModals: (state) => {
      state.queue = [];
    },
  },
})

export const { showModal, hideModal, clearModals } = modalSlice.actions

export default modalSlice.reducer
